import Button from "@mui/material/Button";

const TextButton = ({ label, ...props }) => {

    return (
        <Button
            sx={{
                height: "40px",
                textTransform: "none"
            }}
            variant="text"
            {...props}
        >
            {label}
        </Button>
    );
};

export default TextButton;